import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forEach } from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
import { SharedService } from 'src/app/Service/shared.service';

@Component({
  selector: 'app-appel-concurrence',
  templateUrl: './appel-concurrence.component.html',
  styleUrls: ['./appel-concurrence.component.scss']
})
export class AppelConcurrenceComponent implements OnInit {
  description;
  isArab=false;
  outputLg: any;
  currentlang = '';
  currentUrl: string;
  langue: any;
  datacocurrences;
  report;
  annulation;

  constructor(private global: Global, private service: PublicationsService, private shared: SharedService, private route: ActivatedRoute,private router: Router,private translate: TranslateService) { }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.isArab = lg.code == "ar";
      this.outputLg = lg;
      this.currentlang = lg.url;
      this.currentUrl = this.router.url
      this.langue = lg;
      this.shared.getBlocDescriptionByCode(lg.url, "appelconcurrence").subscribe(data => {
        this.description = data["value"][0];
      })
      this.datacocurrences = [];
      this.service.getAConcurrences(lg.url).subscribe(data => {
        
        this.datacocurrences = data["value"];
        console.log(this.datacocurrences)
        // this.datacocurrences.forEach( item => {
        //   console.log(item)
            
        //     item.AttachmentFiles.forEach((element) => {
              
        //       if (element.FileName.toLowerCase().includes('avis').includes('ac').includes('fr')) {
        //         this.avisFr = element.ServerRelativeUrl;
        //       }
        //       if (element.FileName.toLowerCase().includes('avis').includes('ac').includes('ar')) {
        //         this.avisAr = element.ServerRelativeUrl;
        //       } 
        //       if (element.FileName.toLowerCase().includes('report').includes('fr')) {
        //         this.reportFr = element.ServerRelativeUrl;
        //       }
        //       if (element.FileName.toLowerCase().includes('report').includes('ar')) {
        //         this.reportAr = element.ServerRelativeUrl;
        //       }
        //       if (element.FileName.toLowerCase().includes('annulation').includes('fr')) {
        //         this.annulationFr = element.ServerRelativeUrl;
        //       }
        //       if (element.FileName.toLowerCase().includes('annulation').includes('ar')) {
        //         this.annulationAr = element.ServerRelativeUrl;
        //       }
        //       });
            
        //     });
            
         });

    });
  }

    hasReportFile(item : any): boolean {
      return item.some(status => status.FileName.toLowerCase().includes('report'));
    }
    hasannulationFile(item : any): boolean {
      return item.some(status => status.FileName.toLowerCase().includes('annulation'));
    }
    converteDate(d: string) {
      return this.global.formattedDate(d);
    }
}
